import { Box } from '@material-ui/core';
import { ArrowBackIosOutlined } from '@material-ui/icons';
import NavigationBottom from 'component/navigation/navigation_bottom_home';
import Div100vh from 'react-div-100vh';
import { useHistory } from 'react-router-dom';
// import { ReactComponent as LogoSmall } from "../../assets/svg/logoSmall.svg";
// import logo from '../../assets/img/logo_black.png';
import styles from './styles.module.scss';

function SessionSchedulingLayout(props) {
    const history = useHistory();

    return (
        <Div100vh className={styles.wrapper}>
            <Box className={styles.navigation}>
                {props.showBackBtn && <ArrowBackIosOutlined className={styles.back} onClick={() => history.goBack()} />}
                {/* <img style={{ width: '69px' }} src={logo} alt="" /> */}
                <h1 className={styles.title}>{props?.title}</h1>
            </Box>
            <div className={styles.navigationBottomBorder}>
                <div className={styles.navigationBottomInside} style={{ width: `${props.progress || 0}` }} />
            </div>
            <Box
                className={props?.fullWidthContent ? styles.fullWidthContentContainer : styles.contentContainer}
                style={{ flex: props?.nonFulfilContent ? 'none' : 1 }}
            >
                {props.children}
                <div className={styles.bottomButtonsContainer}>
                    {props.bottomButton && (
                        <Box
                            className={`${styles.bottomButtonWrapper} ${
                                props?.showNavigationBottom ? styles.bottomWithNavigation : ''
                            } ${props?.bottomSecondButton ? styles.firstButton : ''}`}
                        >
                            <button
                                className={`${styles.bottomButton} ${
                                    props.bottomButton.disabled ? styles.bottomButtonDisabled : ''
                                }`}
                                onClick={props.bottomButton.onClick}
                            >
                                {props.bottomButton.label}
                            </button>
                        </Box>
                    )}
                    {props.bottomSecondButton && (
                        <Box
                            className={`${styles.bottomButtonWrapper} ${
                                props?.showNavigationBottom ? styles.bottomWithNavigation : ''
                            }`}
                        >
                            <button
                                className={`${styles.bottomButtonTwo} ${
                                    props.bottomSecondButton.disabled ? styles.bottomButtonDisabled : ''
                                }`}
                                onClick={props.bottomSecondButton.onClick}
                            >
                                {props.bottomSecondButton.label}
                            </button>
                        </Box>
                    )}
                </div>
            </Box>

            {props?.showNavigationBottom && <NavigationBottom />}
        </Div100vh>
    );
}

export default SessionSchedulingLayout;
